var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscodeIconsFileTypeExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-excel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9096 12.4721L6.91602 10.8877V22.595C6.91591 22.7223 6.94092 22.8483 6.98961 22.9658C7.03831 23.0834 7.10973 23.1902 7.19978 23.2801C7.28983 23.37 7.39674 23.4412 7.51438 23.4897C7.63203 23.5382 7.75808 23.563 7.88533 23.5627H23.4041C23.5315 23.5632 23.6577 23.5386 23.7755 23.4902C23.8934 23.4418 24.0005 23.3706 24.0907 23.2807C24.1809 23.1907 24.2525 23.0839 24.3013 22.9662C24.3501 22.8485 24.3751 22.7224 24.375 22.595V18.2814L15.9096 12.4721Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9096 2.4375H7.88533C7.75808 2.43718 7.63203 2.46198 7.51438 2.51048C7.39674 2.55898 7.28983 2.63022 7.19978 2.72012C7.10973 2.81002 7.03831 2.91681 6.98961 3.03437C6.94092 3.15193 6.91591 3.27795 6.91602 3.40519V7.71875L15.9096 13L20.6716 14.5844L24.375 13V7.71875L15.9096 2.4375Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.91602 7.71875H15.9096V13H6.91602V7.71875Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M13.3526 6.6626H6.91602V19.8657H13.3526C13.6091 19.8644 13.8548 19.7622 14.0364 19.581C14.2179 19.3999 14.3208 19.1545 14.3228 18.898V7.63029C14.3208 7.37381 14.2179 7.12842 14.0364 6.94729C13.8548 6.76616 13.6091 6.66387 13.3526 6.6626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M12.8237 7.19043H6.91602V20.3936H12.8237C13.0802 20.3923 13.3258 20.29 13.5074 20.1089C13.689 19.9277 13.7919 19.6823 13.7938 19.4259V8.15812C13.7919 7.90164 13.689 7.65625 13.5074 7.47512C13.3258 7.29399 13.0802 7.1917 12.8237 7.19043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M12.8237 7.19043H6.91602V19.3373H12.8237C13.0802 19.336 13.3258 19.2337 13.5074 19.0526C13.689 18.8715 13.7919 18.6261 13.7938 18.3696V8.15812C13.7919 7.90164 13.689 7.65625 13.5074 7.47512C13.3258 7.29399 13.0802 7.1917 12.8237 7.19043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M12.2948 7.19043H6.91602V19.3373H12.2948C12.5512 19.336 12.7969 19.2337 12.9785 19.0526C13.1601 18.8715 13.263 18.6261 13.2649 18.3696V8.15812C13.263 7.90164 13.1601 7.65625 12.9785 7.47512C12.7969 7.29399 12.5512 7.1917 12.2948 7.19043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.59513 7.19044H12.2948C12.5517 7.19022 12.7982 7.29202 12.9801 7.47348C13.162 7.65493 13.2644 7.90119 13.2649 8.15812V17.8415C13.2644 18.0984 13.162 18.3447 12.9801 18.5261C12.7982 18.7076 12.5517 18.8094 12.2948 18.8092H2.59513C2.46781 18.8096 2.34167 18.7849 2.22393 18.7364C2.1062 18.688 1.99919 18.6168 1.90905 18.5269C1.81891 18.4369 1.74742 18.3301 1.69868 18.2125C1.64993 18.0949 1.62489 17.9688 1.625 17.8415V8.15812C1.62489 8.03081 1.64993 7.90473 1.69868 7.78711C1.74742 7.6695 1.81891 7.56267 1.90905 7.47276C1.99919 7.38285 2.1062 7.31163 2.22393 7.26318C2.34167 7.21473 2.46781 7.19001 2.59513 7.19044Z",
    fill: "url(#paint0_linear_1734_1821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.63086 16.1471L6.67105 12.9914L4.8023 9.85352H6.30298L7.32267 11.8628C7.41692 12.053 7.48517 12.1943 7.51605 12.2886H7.52986C7.59648 12.1364 7.6669 11.9885 7.74111 11.845L8.83148 9.85677H10.2127L8.29605 12.9768L10.2615 16.1496H8.79167L7.61355 13.9469C7.559 13.8521 7.51252 13.7529 7.47461 13.6503H7.45511C7.42068 13.7503 7.37488 13.846 7.31861 13.9355L6.10555 16.1471H4.63086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.4045 2.43751H15.9092V7.71876H24.3746V3.40519C24.3747 3.27788 24.3497 3.1518 24.3009 3.03418C24.2522 2.91657 24.1807 2.80974 24.0906 2.71983C24.0004 2.62992 23.8934 2.5587 23.7757 2.51025C23.658 2.4618 23.5318 2.43708 23.4045 2.43751Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.9092 13H24.3746V18.2812H15.9092V13Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1734_1821",
    x1: 3.65138,
    y1: 6.42994,
    x2: 11.2385,
    y2: 19.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeIconsFileTypeExcel);
export default __webpack_public_path__ + "static/media/vscode-icons_file-type-excel.76af18adc41948773d5a00db1381c5a2.svg";
export { ForwardRef as ReactComponent };